import React from 'react';

export interface RadioButtonProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  disabled?: boolean;
  'data-testid'?: string;
}

export const RadioButton: React.FC<RadioButtonProps> = ({
  checked,
  onChange,
  className = '',
  disabled = false,
  'data-testid': dataTestId,
}) => {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange(true)}
      className={`inline-flex flex-shrink-0 items-center justify-center rounded-full transition-all ${
        checked ? 'border-selected-border border bg-gray-50' : 'border-input-border-gray border bg-gray-50'
      } ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:opacity-80'} ${className}`}
      style={{
        width: '16px',
        height: '16px',
        minWidth: '16px',
        minHeight: '16px',
      }}
      data-testid={dataTestId}
    >
      {checked && (
        <div className="bg-button-primary flex-shrink-0 rounded-full" style={{ width: '8px', height: '8px' }} />
      )}
    </button>
  );
};
